/**
 * ctrLpSwiper — generic Swiper wrapper for ctr-lp-* landing page sections.
 *
 * Usage:
 *   <div x-data="ctrLpSwiper({ slidesPerView: 'auto', spaceBetween: 20 })">
 *     <div class="swiper" x-ref="swiper">...</div>
 *     <button x-ref="prev"></button><button x-ref="next"></button>
 *   </div>
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('ctrLpSwiper', (options = {}) => ({
    swiper: null,
    swiperRetries: 0,

    init() {
      this.initSwiper();
    },

    destroy() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    },

    initSwiper() {
      if (this.swiper) return;

      if (typeof Swiper === 'undefined') {
        if (this.swiperRetries >= 40) return;
        this.swiperRetries += 1;
        window.setTimeout(() => this.initSwiper(), 50);
        return;
      }

      const swiperEl = this.$refs.swiper;
      if (!swiperEl) return;

      const config = Object.assign(
        {
          slidesPerView: 'auto',
          spaceBetween: 20,
          grabCursor: true,
          touchEventsTarget: 'container',
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          },
        },
        options
      );

      if (this.$refs.prev && this.$refs.next) {
        config.navigation = { prevEl: this.$refs.prev, nextEl: this.$refs.next };
      }

      if (this.$refs.pagination) {
        config.pagination = { el: this.$refs.pagination, clickable: true };
      }

      this.swiper = new Swiper(swiperEl, config);
    },

    slideTo(index) {
      if (!this.swiper) return;
      if (this.swiper.params.loop) this.swiper.slideToLoop(index);
      else this.swiper.slideTo(index);
    },
  }));
});
